import { render, staticRenderFns } from "./CargoList.vue?vue&type=template&id=555f2146"
import script from "./CargoList.vue?vue&type=script&lang=js"
export * from "./CargoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports